"use strict";
var __extends = (this && this.__extends) || (function () {
    var extendStatics = function (d, b) {
        extendStatics = Object.setPrototypeOf ||
            ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
            function (d, b) { for (var p in b) if (b.hasOwnProperty(p)) d[p] = b[p]; };
        return extendStatics(d, b);
    };
    return function (d, b) {
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();
Object.defineProperty(exports, "__esModule", { value: true });
exports.NoAnalysisData = exports.NotValidAction = exports.PromotionalCodeError = exports.BillingError = exports.UpdatePasswordError = exports.RequestPasswordError = exports.MailError = exports.LoginError = exports.DatabaseError = exports.UploadError = exports.UpdateError = exports.NotFoundError = exports.ConnectionError = exports.PermissionError = exports.TokenRenewalError = exports.ErrorWithStatusCode = void 0;
/** Generic error extended with status code
 *
 * @returns {Error} error | the error
 *
 * @category ERRORS
 */
var ErrorWithStatusCode = /** @class */ (function (_super) {
    __extends(ErrorWithStatusCode, _super);
    function ErrorWithStatusCode(message, status) {
        var _this = _super.call(this, message) || this;
        _this.status = status;
        return _this;
    }
    return ErrorWithStatusCode;
}(Error));
exports.ErrorWithStatusCode = ErrorWithStatusCode;
/**
 * This error is thrown when a token can be renewel.
 *
 * It can happend whenever:
 * <ul style="list-style: none;">
 * <li>- The webApp is disconnected from the internet
 * <li>- An invalid token is provided
 * <li>- The renewal token is expired
 * </ul>
 * In all cases when receiving this error the user should be logged out
 *
 * @returns {Error} error | the error
 *
 * @category ERRORS
 */
var TokenRenewalError = /** @class */ (function (_super) {
    __extends(TokenRenewalError, _super);
    function TokenRenewalError(message) {
        var _this = _super.call(this, message) || this;
        _this.name = 'TokenRenewalError';
        _this.message = message;
        return _this;
    }
    TokenRenewalError.prototype.toJSON = function () {
        return {
            error: {
                name: this.name,
                message: this.message,
                stacktrace: this.stack
            }
        };
    };
    return TokenRenewalError;
}(Error));
exports.TokenRenewalError = TokenRenewalError;
;
/**
 * When a token protected return with a 403 a PermissionError is trown
 *
 * @returns {Error} error | the error
 *
 * @category ERRORS
 */
var PermissionError = /** @class */ (function (_super) {
    __extends(PermissionError, _super);
    function PermissionError(message) {
        var _this = _super.call(this, message) || this;
        _this.name = 'PermissionError';
        _this.message = message;
        return _this;
    }
    PermissionError.prototype.toJSON = function () {
        return {
            error: {
                name: this.name,
                message: this.message,
                stacktrace: this.stack
            }
        };
    };
    return PermissionError;
}(Error));
exports.PermissionError = PermissionError;
/**
 * When a there is a connection error
 *
 * @returns {Error} error | the error
 *
 * @category ERRORS
 */
var ConnectionError = /** @class */ (function (_super) {
    __extends(ConnectionError, _super);
    function ConnectionError(message) {
        var _this = _super.call(this, message) || this;
        _this.name = 'ConnectionError';
        _this.message = message;
        return _this;
    }
    ConnectionError.prototype.toJSON = function () {
        return {
            error: {
                name: this.name,
                message: this.message,
                stacktrace: this.stack
            }
        };
    };
    return ConnectionError;
}(Error));
exports.ConnectionError = ConnectionError;
/**
 * When a the item don't exist
 *
 * @returns {Error} error | the error
 *
 * @category ERRORS
 */
var NotFoundError = /** @class */ (function (_super) {
    __extends(NotFoundError, _super);
    function NotFoundError(message) {
        var _this = _super.call(this, message) || this;
        _this.name = 'NotFoundError';
        _this.message = message;
        return _this;
    }
    NotFoundError.prototype.toJSON = function () {
        return {
            error: {
                name: this.name,
                message: this.message,
                stacktrace: this.stack
            }
        };
    };
    return NotFoundError;
}(Error));
exports.NotFoundError = NotFoundError;
/**
 * When an item can't be updated
 *
 * @returns {Error} error | the error
 *
 * @category ERRORS
 */
var UpdateError = /** @class */ (function (_super) {
    __extends(UpdateError, _super);
    function UpdateError(message) {
        var _this = _super.call(this, message) || this;
        _this.name = 'UpdateError';
        _this.message = message;
        return _this;
    }
    UpdateError.prototype.toJSON = function () {
        return {
            error: {
                name: this.name,
                message: this.message,
                stacktrace: this.stack
            }
        };
    };
    return UpdateError;
}(Error));
exports.UpdateError = UpdateError;
/**
 * When a file can't be uploaded
 * @returns {Error} error | the error
 *
 * @category ERRORS
 */
var UploadError = /** @class */ (function (_super) {
    __extends(UploadError, _super);
    function UploadError(message) {
        var _this = _super.call(this, message) || this;
        _this.name = 'UploadError';
        _this.message = message;
        return _this;
    }
    UploadError.prototype.toJSON = function () {
        return {
            error: {
                name: this.name,
                message: this.message,
                stacktrace: this.stack
            }
        };
    };
    return UploadError;
}(Error));
exports.UploadError = UploadError;
/**
 * When a localDB error happens
 *
 * @returns {Error} error | the error
 *
 * @category ERRORS
 */
var DatabaseError = /** @class */ (function (_super) {
    __extends(DatabaseError, _super);
    function DatabaseError(message) {
        var _this = _super.call(this, message) || this;
        _this.name = 'DatabaseError';
        _this.message = message;
        return _this;
    }
    return DatabaseError;
}(Error));
exports.DatabaseError = DatabaseError;
/**
 * An error when login the user
 *
 * @returns {Error} error | the error
 *
 * @category ERRORS
 */
var LoginError = /** @class */ (function (_super) {
    __extends(LoginError, _super);
    function LoginError(message) {
        var _this = _super.call(this, message) || this;
        _this.name = 'LoginError';
        _this.message = message;
        return _this;
    }
    return LoginError;
}(Error));
exports.LoginError = LoginError;
/**
 * An error when sending emails
 *
 * @returns {Error} error | the error
 *
 * @category ERRORS
 */
var MailError = /** @class */ (function (_super) {
    __extends(MailError, _super);
    function MailError(message) {
        var _this = _super.call(this, message) || this;
        _this.name = 'MailError';
        _this.message = message;
        return _this;
    }
    return MailError;
}(Error));
exports.MailError = MailError;
/**
 * An error when requesting password reset
 *
 * @returns {Error} error | the error
 *
 * @category ERRORS
 */
var RequestPasswordError = /** @class */ (function (_super) {
    __extends(RequestPasswordError, _super);
    function RequestPasswordError(message, status) {
        var _this = _super.call(this, message, status) || this;
        _this.name = 'RequestPasswordError';
        return _this;
    }
    return RequestPasswordError;
}(ErrorWithStatusCode));
exports.RequestPasswordError = RequestPasswordError;
/**
 * An error when updating the email
 *
 * @returns {Error} error | the error
 *
 * @category ERRORS
 */
var UpdatePasswordError = /** @class */ (function (_super) {
    __extends(UpdatePasswordError, _super);
    function UpdatePasswordError(message) {
        var _this = _super.call(this, message) || this;
        _this.name = 'UpdatePasswordError';
        _this.message = message;
        return _this;
    }
    return UpdatePasswordError;
}(Error));
exports.UpdatePasswordError = UpdatePasswordError;
/**
 * An error with the stripe platform
 *
 * @returns {Error} error | the error
 *
 * @category ERRORS
 */
var BillingError = /** @class */ (function (_super) {
    __extends(BillingError, _super);
    function BillingError(message) {
        var _this = _super.call(this, message) || this;
        _this.name = 'BillingError';
        _this.message = message;
        return _this;
    }
    return BillingError;
}(Error));
exports.BillingError = BillingError;
/**
 * An error with promotional code
 *
 * @returns {Error} error | the error
 *
 * @category ERRORS
 */
var PromotionalCodeError = /** @class */ (function (_super) {
    __extends(PromotionalCodeError, _super);
    function PromotionalCodeError(message) {
        var _this = _super.call(this, message) || this;
        _this.name = 'PromotionalCodeError';
        _this.message = message;
        return _this;
    }
    return PromotionalCodeError;
}(Error));
exports.PromotionalCodeError = PromotionalCodeError;
/**
 * An error when triying to POST an invalid action type
 *
 * @returns {Error} error | the error
 *
 * @category ERRORS
 */
var NotValidAction = /** @class */ (function (_super) {
    __extends(NotValidAction, _super);
    function NotValidAction(message) {
        var _this = _super.call(this, message) || this;
        _this.name = 'NotValidAction';
        _this.message = message;
        return _this;
    }
    return NotValidAction;
}(Error));
exports.NotValidAction = NotValidAction;
/**
 * An error when analysis data is not available
 *
 * @returns {Error} error | the error
 *
 * @category ERRORS
 */
var NoAnalysisData = /** @class */ (function (_super) {
    __extends(NoAnalysisData, _super);
    function NoAnalysisData(message) {
        var _this = _super.call(this, message) || this;
        _this.name = 'NoAnalysisData';
        _this.message = message;
        return _this;
    }
    return NoAnalysisData;
}(Error));
exports.NoAnalysisData = NoAnalysisData;
//# sourceMappingURL=errors.js.map